import React from 'react'
import { RouterConfigItem } from 'sdss/types/view'
import SearchView from 'sdss/views/SearchView'
import SearchRecordView from 'sdss/views/SearchRecordView'
import { generatePath, RouteComponentProps } from 'react-router'

export const SearchPageRoute: RouterConfigItem = {
  name: 'SearchPage',
  title: '搜索页',
  path: '/search/:queryWord',
  render(props: RouteComponentProps<any>) {
    return (<SearchView {...props.match.params} />)
  },
  formatUrl(params: { queryWord?: string }): any {
    return generatePath(this.path, params)
  },
}

export const SearchWithoutQueryPageRoute: RouterConfigItem = {
  name: 'SearchPage',
  title: '搜索页',
  path: '/search',
  render(props: RouteComponentProps<any>) {
    return (<SearchView {...props.match.params} />)
  },
  formatUrl() {
    return generatePath(this.path)
  }
}


export const SearchRecordPageRoute: RouterConfigItem = {
  name: 'SearchRecordView',
  title: '搜索历史',
  component: SearchRecordView,
  path: '/searchRecord',
  formatUrl(): string {
    return this.path
  }
}

export default [
  SearchPageRoute,
  SearchRecordPageRoute,
  SearchWithoutQueryPageRoute
]

